import axios from "axios";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {
  EvaluationListParams,
  WPDangerEvaluation,
} from "../../models/serverModels/permission/WPDangerEvaluation";
import { WPEvaluationMaster } from "../../models/serverModels/permission/WPEvaluationMaster";

const rootApi = process.env.REACT_APP_API_KEY;

const permission = axios.create({
  baseURL: rootApi,
});

export const getList = async (
  params: EvaluationListParams
): Promise<ResponseList<WPDangerEvaluation>> =>
  permission({
    url: "/GetDangerEvaluationList",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<WPDangerEvaluation>> =>
  permission({
    url: `/DangerEvaluation/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (
  params: Params.Create<WPDangerEvaluation>
): Promise<ResponseItem<WPDangerEvaluation>> =>
  permission({
    url: `/DangerEvaluation`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  permission({
    url: `/DangerEvaluation/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<WPDangerEvaluation>
): Promise<ResponseItem<WPDangerEvaluation>> =>
  permission({
    url: `/DangerEvaluation/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);

export const getCheck = async (params: Params.GetItem): Promise<ResponseItem<WPDangerEvaluation>> =>
  permission({
    url: `/GetEvaluationForCheck/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const createCheck = async (
  param: Params.Create<WPDangerEvaluation>
): Promise<ResponseItem<WPDangerEvaluation>> =>
  permission({
    url: `/CheckEvaluation`,
    method: "post",
    data: param,
  }).then((res) => res.data);

// Deprecated -> getCreate2로 변경
export const getCreate = async (
  params: Params.GetItem
): Promise<ResponseItem<WPDangerEvaluation>> =>
  permission({
    url: `/DangerNewEvaluation`,
    method: "get",
    params,
  }).then((res) => res.data);

// note : SmokingScully Add
export const getRevisionList = async (params: Params.GetItem): Promise<ResponseList<WPDangerEvaluation>> =>
  permission({
    url: `/GetRevisionList/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const getRevisionMaster = async (params: Params.GetItem): Promise<ResponseList<WPDangerEvaluation>> =>
  permission({
    url: `/GetRevisionMaster/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);
export const getCreate2 = async (
  params: Params.GetItem
): Promise<ResponseItem<WPDangerEvaluation>> =>
  permission({
    url: `/DangerNewEvaluation`,
    method: "get",
    params,
  }).then((res) => res.data);